import { render, staticRenderFns } from "./SignUpdate.vue?vue&type=template&id=6b0ab9bc&scoped=true&"
import script from "./SignUpdate.vue?vue&type=script&lang=js&"
export * from "./SignUpdate.vue?vue&type=script&lang=js&"
import style0 from "./SignUpdate.vue?vue&type=style&index=0&id=6b0ab9bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0ab9bc",
  null
  
)

export default component.exports